import React, { useEffect, useState } from 'react';
import { getFlowPaper, FlowPaper as FlowPaperData } from '../api/strategy';
import './StrategyReports.css';
const fmt = (v: number | null, dp = 3) => v == null || Number.isNaN(v) ? '—' : v.toFixed(dp);
const signed = (v: number | null, dp = 3) => v == null || Number.isNaN(v) ? '—' : (v >= 0 ? '+' : '') + v.toFixed(dp);
const when = (ts: string) => ts ? new Date(ts).toLocaleString('en-AU', { timeZone: 'Australia/Sydney' }) : '—';
export default function FlowHistory() {
  const [data, setData] = useState<FlowPaperData | null>(null);
  const [date, setDate] = useState('');
  const [error, setError] = useState('');
  useEffect(() => {
    let cancelled = false;
    setData(null); setError('');
    getFlowPaper(500, date || undefined).then(value => { if (!cancelled) setData(value); })
      .catch(err => { if (!cancelled) setError(err?.message || 'Could not load Flow history'); });
    return () => { cancelled = true; };
  }, [date]);
  return <div className="sr-page"><h1>Flow history</h1>
    <p>Archived ledger view. Displays up to 500 existing records. Times are Sydney local time.</p>
    <label>Racing date <input type="date" value={date} onChange={e => setDate(e.target.value)} /></label>
    {date && <button onClick={() => setDate('')}>Most recent</button>}
    {error && <p role="alert">{error}</p>}
    {!data && !error && <p>Loading history…</p>}
    {data && data.picks.length === 0 && <p>No records for this period.</p>}
      {data && data.picks.length > 0 && (
        <table className="sr-table">
          <thead><tr>
            <th>When</th><th>Race</th><th>Runner</th><th>Regime</th><th>Qualified?</th><th>Bet</th>
            <th>Signal</th><th>q-move</th><th>under-react</th><th>spike z</th>
            <th>Surface</th><th>Window</th><th>Why</th>
          </tr></thead>
          <tbody>
            {data.picks.map((p) => {
              const blocked = p.size_stage === 'blocked';
              const betCell = p.size_stage === 'live' && p.stake > 0
                ? `$${p.stake} @ ${p.matched_price ?? p.offer_price ?? '?'}`
                : blocked ? `blocked` : (p.size_stage === 'shadow' ? 'paper' : '—');
              return (
                <tr key={p.pick_id} style={p.dumb_money_flag ? { background: '#fef2f2' } : blocked ? { opacity: 0.6 } : undefined}>
                  <td>{when(p.entered_ts)}</td>
                  <td>{p.race_id}</td>
                  <td title={`Betfair selection ${p.runner_id}`} style={{ fontWeight: 600 }}>{p.runner_name || `#${p.runner_id}`}</td>
                  <td>
                    <span className="sr-pill" style={{ background: p.regime === 'A' ? '#dbeafe' : '#ede9fe', color: p.regime === 'A' ? '#1e40af' : '#5b21b6' }}>
                      {p.regime}{p.dumb_money_flag ? ' · FADE' : ''}
                    </span>
                  </td>
                  <td title={p.qualified ? 'Signal + window open + not a dumb-money fade → the engine wanted to back this' : 'Did not clear all three: a live signal, the fire window OPEN, and not a fade'}
                    style={{ fontWeight: 700, color: p.qualified ? '#166534' : '#9ca3af' }}>
                    {p.qualified ? '✓ YES' : '—'}
                  </td>
                  <td title={p.block_reason ?? ''}>{betCell}</td>
                  <td className="sr-num">{fmt(p.signal_at_entry)}</td>
                  <td className="sr-num">{signed(p.q_move)}</td>
                  <td className="sr-num">{signed(p.under_reaction)}</td>
                  <td className="sr-num">{fmt(p.spike_z, 2)}</td>
                  <td>{p.surface ?? '—'}</td>
                  <td>{p.window_state ?? '—'}</td>
                  <td style={{ maxWidth: 420 }}>{p.reason}{blocked && p.block_reason ? ` — not bet: ${p.block_reason}` : ''}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
  </div>;
}
